const SelectField2 = ({
  name,
  register,
  data,
  label,
  labelWidth,
  errors,
  defaultValue,
  valueAsNumber,
  disabled,
}) => {
  return (
    <div className="input-container py-2">
      <div className="flex gap-4 justify-center items-center">
        <label
          htmlFor={name}
          className={"block mb-0.5 text-text-1/90 font-medium " + labelWidth}
        >
          {label}
        </label>
        <select
          className="w-full bg-content px-2 py-2 border border-l rounded-md border-bkg2 text-base focus:border-primary text-text-1/75 outline-none"
          disabled={disabled}
          defaultValue={defaultValue ? defaultValue : ""}
          {...register(name, { valueAsNumber })}
        >
          {data.map((item) => {
            return (
              <option className="text-sm" key={item.id} value={item.id}>
                {item.name}
              </option>
            );
          })}
        </select>
      </div>
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default SelectField2;
